module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"preventive-measures:title":"Профилактические мероприятия по БДД","preventive-measures:add-button":"Добавить мероприятие"},"en":{"preventive-measures:title":"Preventive measures for road safety","preventive-measures:add-button":"Add measure"}}')
  delete Component.options._Ctor
}
